/**
 * The Plan — Top-level Surface
 *
 * Sidebar-free consumer surface, mounted the same way Decision Brief is
 * (see src/pages/brief/BriefApp.tsx): outside the /prioritization/* Layout
 * chrome, so it renders with no admin nav — just the page. Routes under
 * /plan/*.
 *
 * Auth-gated (RequireAuth wraps the /plan/* mount in App.tsx, same as
 * every other top-level surface).
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import ThePlanPage from './ThePlanPage';

export default function PlanSpineApp() {
  return (
    <Routes>
      <Route index element={<ThePlanPage />} />
      <Route path="*" element={<Navigate to="/plan" replace />} />
    </Routes>
  );
}
